import { useTranslation } from "react-i18next";

import { useGroupedBrands } from "components/BrandGroupSelect/hooks/useGroupedBrands";
import { getGroupedBrandOptions, toBrandGroupIds } from "components/BrandGroupSelect/utils";
import { toGroupValue } from "modules/BrandsDashboard/utils";

import type { BrandGroupID } from "models";

type UseBrandGroupSelectProps = {
  selectedBrandGroupIds: BrandGroupID[];
  onChange: (brandGroupIds: BrandGroupID[]) => void;
  showAllBrands?: boolean;
};

export const useBrandGroupSelect = ({ selectedBrandGroupIds, onChange, showAllBrands }: UseBrandGroupSelectProps) => {
  const { t } = useTranslation();

  const groupedBrands = useGroupedBrands();

  const selectedOptionValues = selectedBrandGroupIds.map(toGroupValue);
  const allBrandsText = showAllBrands ? t("v8_all_brands", "All Brands") : undefined;
  const brandsWithGroupsOptions = getGroupedBrandOptions({ groupedBrands, selectedOptionValues, allBrandsText });

  const handleOnSelectionChange = (selectedValues: string[]) =>
    onChange(toBrandGroupIds({ brandGroups: groupedBrands.brandGroups, selectedValues, selectedBrandGroupIds }));

  return { brandsWithGroupsOptions, selectedOptionValues, handleOnSelectionChange };
};
